import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface ULProps
  extends HTMLAttributes<HTMLUListElement>,
    CommonComponentProps {}

export function UL({ children, className, ...rest }: ULProps) {
  return (
    <ul
      className={cx("ml-6 list-disc [&>li]:mt-2 font-sans", className)}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </ul>
  );
}

interface OLProps
  extends HTMLAttributes<HTMLOListElement>,
    CommonComponentProps {}

export function OL({ children, className, ...rest }: OLProps) {
  return (
    <ol
      className={cx("ml-6 list-disc [&>li]:mt-2 font-sans", className)}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </ol>
  );
}

interface LIProps extends HTMLAttributes<HTMLLIElement>, CommonComponentProps {}

export function LI({ children, className, ...rest }: LIProps) {
  return (
    <li className={className} {...cleanHtmlRestProps(rest)}>
      {children}
    </li>
  );
}
